
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import workspaceCockpitDialogDescriptor from './WorkspaceCockpitDialogDescriptor.json'
import { mapGetters } from 'vuex'

export default defineComponent({
    name: 'workspace-cockpit-dialog',
    components: { Dialog },
    props: { visible: { type: Boolean } },
    emits: ['close'],
    data() {
        return {
            workspaceCockpitDialogDescriptor,
            url: ''
        }
    },
    computed: {},
    watch: {},
    created() {
        this.createUrl()
    },
    methods: {
        ...mapGetters(['getLocale']),
        createUrl() {
            const user = (this.$store.state as any).user
            const locale = this.getLocale()
            const language = locale.split('_')[0]
            const uniqueID = user.userUniqueIdentifier
            const country = locale.split('_')[1]

            this.url = process.env.VUE_APP_HOST_URL + `/knowagecockpitengine/api/1.0/pages/edit?NEW_SESSION=TRUE&SBI_LANGUAGE=${language}&SBI_SCRIPT=&user_id=${uniqueID}&SBI_COUNTRY=${country}&SBI_ENVIRONMENT=WORKSPACE&IS_TECHNICAL_USER=true&documentMode=EDIT`
        },
        close() {
            this.$emit('close')
        }
    }
})
